import { useTheme } from '@emotion/react'
import { Stack, TextField, Typography } from '@mui/material'

export interface CcatFormValues {
    rawScore?: number | null
    percentile?: number | null
}

export interface CcatErrorFormValues {
    rawScore: string
    percentile: string
}

export interface CcatScoresProps {
    isEditing: boolean
    onScoreUpdate: (newValues: CcatFormValues) => void
    updateErrorValues: (newValues: CcatErrorFormValues) => void
    errors: CcatErrorFormValues
    formValues: CcatFormValues
}

const CcatScores: React.FC<CcatScoresProps> = ({
    isEditing,
    onScoreUpdate,
    updateErrorValues,
    errors,
    formValues,
}) => {
    const theme = useTheme()
    return (
        <>
            <Typography variant="body2">CCAT</Typography>

            <Stack direction="column" spacing={isEditing ? 2 : 1}>
                {isEditing ? (
                    <TextField
                        type="number"
                        fullWidth
                        inputProps={{
                            type: 'number',
                            min: 0,
                            max: 50,
                            step: 1,
                        }}
                        InputLabelProps={{ shrink: true }}
                        size="medium"
                        label="Raw Score"
                        name="rawScore"
                        value={formValues.rawScore ?? ''}
                        error={errors.rawScore !== ''}
                        onChange={(e) => {
                            const newValue = +e.target.value
                            onScoreUpdate({
                                ...formValues,
                                rawScore: newValue,
                            })
                            if (
                                e.target.value &&
                                (newValue < 0 || newValue > 50)
                            ) {
                                updateErrorValues({
                                    ...errors,
                                    rawScore:
                                        'Percentile must be between 0 and 50',
                                })
                                return
                            }
                            updateErrorValues({ ...errors, rawScore: '' })
                        }}
                    />
                ) : (
                    <Typography
                        variant="body2"
                        color={theme.palette.other.secondary_light}
                    >
                        {`Raw Score: ${formValues.rawScore ?? '-'}`}
                    </Typography>
                )}
                {isEditing ? (
                    <TextField
                        type="number"
                        fullWidth
                        inputProps={{
                            type: 'number',
                            min: 0,
                            max: 100,
                            step: 1,
                        }}
                        InputLabelProps={{ shrink: true }}
                        size="medium"
                        label="Percentile"
                        name="percentile"
                        value={formValues.percentile ?? ''}
                        error={errors.percentile !== ''}
                        onChange={(e) => {
                            const newValue = +e.target.value
                            onScoreUpdate({
                                ...formValues,
                                percentile: newValue,
                            })
                            if (
                                e.target.value &&
                                (newValue < 0 || newValue > 100)
                            ) {
                                updateErrorValues({
                                    ...errors,
                                    percentile:
                                        'Percentile must be between 0 and 100',
                                })
                                return
                            }
                            updateErrorValues({ ...errors, percentile: '' })
                        }}
                    />
                ) : (
                    <Typography
                        variant="body2"
                        color={theme.palette.other.secondary_light}
                    >
                        {`Percentile: ${formValues?.percentile ?? '-'}`}
                    </Typography>
                )}
            </Stack>
        </>
    )
}

export default CcatScores
